"use client";

import { Label } from "@/components/ui/label";
import { useInteractions } from "../../../hooks/interactionsProvider";
import StepHeader from "../../ui/stepHeader";
import { Textarea } from "@/components/ui/textarea";
import FormFields from "./formFields";
import { VideoInteraction, VideoInteractionType } from "@yedalabs/schema";
import ContinueButton from "../../ui/continueButton";
import { Input } from "@/components/ui/input";
import { t } from "@/lib/localization";

export default function QuestionStep() {
    const { selectedInteraction, updateInteraction } = useInteractions();

    if (!selectedInteraction) return <></>;

    const copy = getCopy(selectedInteraction.type);

    return (
        <div className="flex flex-col gap-6 w-full">
            <StepHeader
                title={{
                    keyName: copy.title.keyName,
                    defaultValue: copy.title.defaultValue,
                }}
                description={{
                    keyName: copy.description.keyName,
                    defaultValue: copy.description.defaultValue,
                }}
            />

            <div className="flex flex-col gap-2">
                <Label htmlFor="interactionQuestion">
                    {t(copy.questionLabel.keyName, undefined, undefined)}
                </Label>
                <Textarea
                    id="interactionQuestion"
                    value={selectedInteraction?.content.question || ""}
                    onChange={(e) =>
                        updateInteraction(selectedInteraction!.id, {
                            content: {
                                ...selectedInteraction?.content,
                                question: e.target.value,
                            },
                        } as VideoInteraction)
                    }
                />
            </div>

            {selectedInteraction.type === "form" && <FormFields />}

            {selectedInteraction.type === "link" && (
                <div className="flex flex-col gap-2 mb-2">
                    <Label htmlFor="linkUrl">
                        {t(copy.questionLabel.keyName, undefined, undefined)}
                    </Label>
                    <Input
                        id="linkUrl"
                        value={(selectedInteraction?.content).url}
                        onChange={(e) =>
                            updateInteraction(selectedInteraction!.id, {
                                content: {
                                    ...selectedInteraction?.content,
                                    url: e.target.value,
                                },
                            })
                        }
                    />
                </div>
            )}

            <ContinueButton />
        </div>
    );
}

const getCopy = (type: VideoInteractionType) => {
    if (type === "form") {
        return {
            title: {
                keyName: "interaction-modal.form.header.title",
                defaultValue: "טופס",
            },
            description: {
                keyName: "interaction-modal.form.header.description",
                defaultValue: "הזינו את הכותרת ובחרו את השדות",
            },
            questionLabel: {
                keyName: "interaction-modal.form-question.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "rating") {
        return {
            title: {
                keyName: "interaction-modal.rating.header.title",
                defaultValue: "דירוג",
            },
            description: {
                keyName: "interaction-modal.rating.header.description",
                defaultValue: "הזינו את הכותרת שלכם",
            },
            questionLabel: {
                keyName: "interaction-modal.rating.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "link") {
        return {
            title: {
                keyName: "interaction-modal.link.header.title",
                defaultValue: "לינק",
            },
            description: {
                keyName: "interaction-modal.link.header.description",
                defaultValue: "בחרו כותרת והזינו את כתובת הלינק",
            },
            questionLabel: {
                keyName: "interaction-modal.link.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "audio") {
        return {
            title: {
                keyName: "interaction-modal.audio.header.title",
                defaultValue: "אודיו",
            },
            description: {
                keyName: "interaction-modal.audio.header.description",
                defaultValue: "הזינו את הכותרת שלכם",
            },
            questionLabel: {
                keyName: "interaction-modal.audio.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "cloze") {
        return {
            title: {
                keyName: "interaction-modal.cloze.header.title",
                defaultValue: "השלמת משפטים",
            },
            description: {
                keyName: "interaction-modal.cloze.header.description",
                defaultValue: "הזינו את הכותרת שלכם",
            },
            questionLabel: {
                keyName: "interaction-modal.cloze.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "match") {
        return {
            title: {
                keyName: "interaction-modal.match.header.title",
                defaultValue: "התאמת קלפים",
            },
            description: {
                keyName: "interaction-modal.match.header.description",
                defaultValue: "הזינו את הכותרת שלכם",
            },
            questionLabel: {
                keyName: "interaction-modal.match.label",
                defaultValue: "כותרת",
            },
        };
    } else if (type === "aiChat") {
        return {
            title: {
                keyName: "interaction-modal.ai-chat.header.title",
                defaultValue: "שיחה עם AI",
            },
            description: {
                keyName: "interaction-modal.ai-chat.header.description",
                defaultValue:
                    "הזינו את השאלה שעליה ה-AI ישוחח עם התלמיד וייבחן אותו",
            },
            questionLabel: {
                keyName: "interaction-modal.ai-chat.question.label",
                defaultValue: "שאלה",
            },
        };
    } else {
        return {
            title: {
                keyName: "interaction-modal.question.header.title",
                defaultValue: "שאלה",
            },
            description: {
                keyName: "interaction-modal.question.header.description",
                defaultValue: "הזינו את השאלה שלכם",
            },
            questionLabel: {
                keyName: "interaction-modal.question.label",
                defaultValue: "שאלה",
            },
        };
    }
};
